import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/ro/all';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmailsRoutingModule } from './emails-routing.module';
import { EmailsListComponent } from './emails-list/emails-list.component';
import { EmailsListFilterComponent } from './emails-list/emails-list-filter/emails-list-filter.component';
import { EmailsCardViewComponent } from './emails-list/emails-card-view/emails-card-view.component';
import { EmailsAddEditComponent } from './emails-list/emails-add-edit/emails-add-edit.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    EmailsRoutingModule,
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    PipeModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
  ],
  declarations: [EmailsListComponent, EmailsListFilterComponent, EmailsCardViewComponent, EmailsAddEditComponent],
})
export class EmailsModule {}
